// extracted by mini-css-extract-plugin
export default {"list":"styles__list--TFo9y","animated-item":"styles__animated-item--DioBJ","rank-item":"styles__rank-item--AHN5E"};